import React from 'react'
import { TableColumnContainer, TableItemView } from 'components/shared'

import "./styles.css";

/**
 * @function EntitlementsAccountsProfilesTableHeader
 * @param {React.Component} children - Allows us to inject other components/content. 
 * @returns {React.Component}
 */
export default function EntitlementsAccountsProfilesTableHeader(props) {
    return (
        <TableColumnContainer className="entitlements-accounts-profile-table-header">
            {props.children}
        </TableColumnContainer>
    )
}

/**
 * @function AccountsProfilesTableHeaderItemView 
 * @param {STRING} text - Allows us to set the text data column in the table header.   
 * @param {STRING} className - Allows us to set a custom className. Use "first-col and skewed-col" classses to applied table header styles."
 * @returns {React.Component}
 */
export function AccountsProfilesTableHeaderItemView(props) {
    const className = props.className ?? "";
    const text = props.text ?? "";
    const dataPointLabel = props.dataPoint ? { "data-point" : `${ props.dataPoint }_Label` } : {};

    return (
        <TableItemView className={className}>
            <div className="text-container flex-container align-bottom justify-center">
                <p>
                    <span{ ...dataPointLabel }>{text}</span>
                </p>
            </div>
        </TableItemView>
    )
}